import * as React from "react";
import { styled } from "@linaria/react";

import Demo, { DemoSliderControl } from "@/components/Demo";
import ClientOnlySnippet from "@/components/CodeSnippet/ClientOnlySnippet";

function HueRotate({}) {
  return (
    <Demo
      initialValues={{
        radius: 0,
        sepia: 0,
      }}
      controlPosition="bottom"
      outputWrapper={null}
      controls={[
        <DemoSliderControl
          key="radius"
          id="radius"
          label="Blur radius"
          min={0}
          max={16}
          step={0.1}
          previewRenderer={(val) => `${val}px`}
        />,
        <DemoSliderControl
          key="sepia"
          id="sepia"
          label="Sepia percentage"
          min={0}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
      ]}
    >
      {({ radius, sepia }) => {
        return (
          <Wrapper>
            <Card
              style={{
                filter: `blur(${radius}px) sepia(${sepia}%)`,
              }}
            >
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since 1966, when designers at Letraset and James
                Mosley, the librarian at St Bride Printing Library in London,
                took a 1914 Cicero translation and scrambled it to make dummy
                text for Letraset's Body Type sheets.
              </p>
            </Card>
            <CodeWrapper>
              <ClientOnlySnippet
                lockedToColorMode="dark"
                omitCopyButton
                lang="css"
                code={`\
.lorem-card {
  filter: blur(${radius}px) sepia(${sepia}%);
}\
`}
              />
            </CodeWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid var(--color-content-outline);
  border-radius: 8px;
`;

const Card = styled.div`
  --selection-text-color: black;
  --selection-background-color: hsl(48deg 100% 60%);
  padding: 1rem;
  border-radius: 4px;
  background: var(--color-adaptive-white);
  color: black;
  font-size: 1rem;
  max-width: 420px;
`;

const CodeWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 420px;
  min-height: 8rem;
  border: 1px solid var(--color-gray-200);
  background: var(--color-background);
  align-self: center;
  border-radius: 4px;
`;

export default HueRotate;
